import React from "react";
/**
 * @param {{label: string, value: string}} options
 */
const Select = ({
  options = [],
  refs,
  placeholder = "선택",
  onChange = () => {},
  value,
  className = "",
  style,
  required = false,
  defaultChecked,
}) => {
  return (
    <div className="dropdown dropdown-90" style={style}>
      <select
        onChange={onChange}
        {...refs}
        placeholder={placeholder}
        className={`btn btn-secondary dropdown-toggle dropdown-btn ${className}`}
        type="button"
        value={value}
        required={required}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {options?.map((option, i) => (
          <option
            key={option.value || `${value}${i}`}
            value={option.value || ""}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

// User.propTypes = {
//   /**
//    * User's name
//    */
//   name: PropTypes.string.isRequired,
//   /**
//    * User's age
//    */
//   age: PropTypes.number,
// };

// User.defaultProps = {
//   text: "Jitendra Nirnejak",
//   age: 21,
// };

export default Select;
